import React from "react";

export default function WideCTA({ data }) {
  const appMode = process.env.APP_MODE;
  const signupLink = data?.btn?.href?.[appMode] || data?.btn?.href;
  return (
    <section className="cta-contrast has-noimage">
      <article className="mx-auto lg:text-center">
        <h2 className="text-lg lg:mb-5 md:mb-5">{data.title}</h2>
        <a
          href={signupLink}
          className="btn-primary btn-lg md:w-100"
          id="blue-cta-sign-me-up"
          data-testid={`blue-cta-sign-me-up-${appMode}`}
        >
          <span>{data.btn.text}</span>
        </a>
      </article>
    </section>
  );
}
